import emojiRegex from 'emoji-regex';

export default function getFirstEmojiFromString(input: string): string | undefined {
  const regex = emojiRegex();
  return input.match(regex)?.[0];
}
